<mat-card class="card-login  mat-elevation-z5">
	<mat-card-title>
		<div class="flex-center" style="margin-top: 20px; font-size: 24px; font-weight: 500;">
			Benutzer-Login
		</div>
	</mat-card-title>
	<div  style="margin-top: 50px;" >
		<form #fLogin="ngForm" >
			<mat-form-field class="flex-center">
				<input class="flex-center" matInput  placeholder="Login-Name"  [(ngModel)]="globserv.Login.LoginName"  name="LoginName" type="text" >
			</mat-form-field>
			
			<mat-form-field class="flex-center">
				<input class="flex-center" matInput placeholder="Passwort" [(ngModel)]="globserv.Login.Passwort"  name="Password" type="password" required minlength="3" >
			</mat-form-field>
			<div class='flex-center' >
				<button mat-flat-button [disabled]="!fLogin?.valid"	color="primary"(click)="doLogin()" style="width: 200px; margin-top: 50px; margin-bottom: 20px;">Login</button>
			</div>
		</form>
	</div>
</mat-card>

